import { prop } from 'ramda'
import { useIsOwner, useSessionPermission, useIsMaster } from '@btime/react-session'

import { useNavigationWithModalCloser } from '../../contexts/NavigationContext'
import {
  useOpenChecklistModal,
  useOpenChecklistPreviewModal,
  useOpenCloneChecklistModal
} from '../../routes/modals/modalsActions'
import { useRemoveChecklists } from '../../../modules/checklists/list/_requests/removeChecklists'

export const useChecklistDetailsAction = item => {
  const openDetailsModal = useOpenChecklistModal()

  return {
    click: () => openDetailsModal(item)
  }
}

export const useChecklistLogsActions = item => {
  const isOwner = useIsOwner()
  const navigate = useNavigationWithModalCloser()

  return {
    click: () => navigate(`/logs?entityChecklistIds=${item.id}`),
    link: `/logs?entityChecklistIds=${item?.id}`,
    hasPermission: isOwner
  }
}

export const useChecklistSimulationAction = item => {
  const openPreviewModal = useOpenChecklistPreviewModal()

  return {
    click: () => openPreviewModal(item)
  }
}

export const useChecklistCloneAction = item => {
  const openCloneModal = useOpenCloneChecklistModal()
  const canClone = useSessionPermission('createChecklist')

  return {
    click: () => openCloneModal({ id: item?.id }),
    hasPermission: canClone
  }
}

export const useChecklistSaveAsTemplateAction = item => {
  const openCloneModal = useOpenCloneChecklistModal()
  const canSave = useIsMaster()

  return {
    click: () => openCloneModal({ id: item?.id, toTemplates: true }),
    hasPermission: canSave
  }
}

export const useChecklistEditAction = item => {
  const navigate = useNavigationWithModalCloser()
  const canEdit = useSessionPermission('editChecklist')

  return {
    click: () => navigate(`/checklists/${item.id}/edit`),
    link: `/checklists/${prop('id', item)}/edit`,
    hasPermission: canEdit
  }
}

export const useChecklistRemoveAction = item => {
  const canDelete = useSessionPermission('deleteChecklist')
  const [deleteItems, _bulkState] = useRemoveChecklists()

  return {
    click: () => deleteItems([item.id]),
    hasPermission: canDelete
  }
}

// TODO - validade if is new table or not (change ids to items, if is the new one)
export const useChecklistsLogsAction = ids => {
  const isOwner = useIsOwner()
  const navigate = useNavigationWithModalCloser()

  return {
    click: () => navigate(`/logs?entityChecklistIds=${ids?.join(',')}`),
    link: `/logs?entityChecklistIds=${ids?.join(',')}`,
    hasPermission: isOwner
  }
}

export const useChecklistsRemoveAction = ids => {
  const canDelete = useSessionPermission('deleteChecklist')
  const [deleteItems, _bulkState] = useRemoveChecklists()
  return {
    click: () => deleteItems(ids),
    hasPermission: canDelete
  }
}
